import { FilterConfig } from '@mri/types';

export function generateFiltersMobile(): FilterConfig{
  return {
    title: 'Fitrar Vehiculos',
    elements:  [
      {
        id: 'name',
        key: 'name',
        label: 'Placa',
        type: 'string'
      },
      {
        id: 'deviceId',
        key: 'deviceId',
        type: 'options',
        label: 'Dispositivo',
        optionsUrl: 'devices/choice'
      },
      {
        id: 'phoneLine',
        key: 'phoneLine',
        type: 'string',
        label: 'Linea telefonica',
      },
      {
        id: 'listenerId',
        key: 'listenerId',
        label: 'Servidor',
        type: 'options',
        options: [
          {
            label: 'Servidor 1',
            value: '2'
          },
          {
            label: 'Servidor 2',
            value: '3'
          },
          {
            label: 'Servidor 3',
            value: '4'
          },
          {
            label: 'Servidor 4',
            value: '5'
          }
        ]
      },
      {
        id: 'propertyId',
        key: 'propertyId',
        label: 'Propietario',
        type: 'options',
        optionsUrl: 'properties/choice'
      }
    ]
  }
}
